<!-- TrustBox widget - Review Collector -->
<div
  *appFeatureFlag="'isTrustpilotAvailable'"
  #trustbox
  class="trustpilot-widget"
  data-locale="en-GB"
  data-template-id="56278e9abfbbba0bdcd568bc"
  data-businessunit-id="6a9689d98716e8b55449b156"
  data-style-height="52px"
  data-style-width="100%"
>
  <a href="https://uk.trustpilot.com/review/www.identi.pet" target="_blank" rel="noopener">
    Trustpilot
  </a>
</div>
<!-- End TrustBox widget -->
